<ion-content>
    <div class="ion-padding container-flex">

      <button class="bt-close"><ion-icon name="close-circle" (click)="close()"></ion-icon></button>

      <div class="header">
        <h2 class="title"><ion-icon name="chatbubbles"></ion-icon> Talk to GoSpread</h2>
        <p>We are here to help!</p>
      </div>

      <form [formGroup]="form">

        <ion-item color="transparent"       class="ion-margin-bottom">
          <ion-textarea clearOnEdit="true" formControlName="mensagem" 
            color="light"
            cols="20" 
            placeholder="Insert your message..."></ion-textarea>
        </ion-item>  

        <button shape="round" 
        (click)="sendMessage()" 
        class="ion-margin-top button-bigger animation-none">Send Message</button>

      </form>

      
      
  </div>
</ion-content>
